'use client';
import React, { useState } from 'react';
import Steepper2 from '@/components/Stepper/Stepper2';
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb';
import { useAuth } from '@/contexts/AuthContext';
import { useDialog } from '@/hooks/useDialog';
import Step1 from './components/step1';
import Step2 from './components/step2';
import Step3 from './components/step3';

const Certificadoobra = () => {
    const [infoCert, setInfoCert] = useState(null)
    const [data, setData] = useState([]);
    const [essolvente, setEssolvente] = useState(false);
    const [currentStep, setCurrentStep] =useState(0); 
    const [loading, setLoading] = useState(true);
    const [prevCarg, setPrevCarg] = useState(false);
    const [requisitos, setRequisitos] = useState([]) ;
    const { user, loading: userLoading } = useAuth();
    const { show } = useDialog();

    const steps = [
        {
            title: 'Requisitos',
            body: (<Step1 user={user} userLoading={userLoading} loading={loading} setEssolvente={setEssolvente} setLoading={setLoading} show={show} prevCarg={prevCarg} requisitos={requisitos} setRequisitos={setRequisitos} />),
            showNext: true,
            onNext: async () => {
                if(!essolvente){
                    show({ type: 'warning', title: 'No se puede continuar', message: 'Debes tener todos los requisitos aprobados para continuar' })
                    return false
                } else {
                    return true
                }
            }
        },
        {
            title: 'Seleccione el Certificado',
            body: <Step2 user={user} show={show} currentStep={currentStep} setCurrentStep={setCurrentStep} setPrevCarg={setPrevCarg} setInfoCert={setInfoCert} data={data} setData={setData} />,
            showNext: false
        },
        {
            title: 'Certificado',
            body: <Step3 show={show} user={user} infoCert={infoCert} />,
            showNext: false
        }
    ]

    return (
        <>
            <Breadcrumb pageName='Generacion de Certificado de Obra' />
            <Steepper2 
              steps={steps}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
            />
            
        </>
    )
}

export default Certificadoobra;